const T_PREFIX = "deal";

export const defaultDealTrns = {
  rejectButton: `${T_PREFIX}.reject-btn`,
  confirmButton: `${T_PREFIX}.confirm-btn`,
};

export const approvedDealTrns = {
  downloadButton: `${T_PREFIX}.download-btn`,
  exportButton: `${T_PREFIX}.export-btn`,
  completeButton: `${T_PREFIX}.complete-btn`,
};

export const metaTrns = {
  title: `${T_PREFIX}.meta.title`,
  description: `${T_PREFIX}.meta.description`,
};
